import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { useNavigation } from "@react-navigation/core"
import React from "react"
import { TouchableOpacity, View } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"
import SvgIconRetour from "../CustomIcon/SvgIconRetour"
import SvgIvehteLogo from "../CustomIcon/SvgIvehteLogo"
import SvgSettings from "../CustomIcon/SvgSettings"
import SvgSettingsActive from "../CustomIcon/SvgSettingsActive"
import styles from "./styles"

const CustomHeader = (props) => {
    const { showGoBack, showParams, editing } = props
    const navigation = useNavigation()
    const logoStyle =
        (showGoBack && showParams) || (showGoBack && showParams && editing)
            ? { paddingLeft: RFValue(30) }
            : showGoBack && !showParams
            ? styles.logoStyle
            : !showGoBack && showParams
            ? styles.logoStyle
            : undefined

    const goBack = () => navigation.goBack()
    const goToUserSettings = () => navigation.navigate("UserSettings")
    const goToHomePage = () => navigation.navigate("Main")

    return (
        <View style={styles.container}>
            <TouchableOpacity onPress={goBack}>{showGoBack && <SvgIconRetour />}</TouchableOpacity>

            <TouchableOpacity onPress={goToHomePage} style={logoStyle}>
                <SvgIvehteLogo />
            </TouchableOpacity>

            <TouchableOpacity onPress={goToUserSettings}>
                {showParams ? (
                    editing ? (
                        <View style={styles.content}>
                            <SvgSettingsActive width={25} height={25} />
                            <OpenSansText
                                style={{ ...styles.label, color: baseColors.orange.primary }}
                                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                fontSize={RFValue(12)}
                            >
                                Paramètres
                            </OpenSansText>
                        </View>
                    ) : (
                        <View style={styles.content}>
                            <SvgSettings width={25} height={25} />
                            <OpenSansText
                                style={{ ...styles.label, color: baseColors.green.primary }}
                                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                fontSize={RFValue(12)}
                            >
                                Paramètres
                            </OpenSansText>
                        </View>
                    )
                ) : undefined}
            </TouchableOpacity>
        </View>
    )
}

export default CustomHeader
